import React from "react";

import TokenLoginContainer from "../containers/TokenLogin";

const TokenLogin = () => <TokenLoginContainer />;

export default TokenLogin;
